module.exports = __webpack_public_path__ + "img/upliving.4edd0e4a.png";